import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { WkoHighchart } from "../WkoHighchart";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
export const NcPerVesselChart = ({ options, title = "Monthly trends per visit", }) => {
    const [loading, setLoading] = useState(false);
    const [series, setSeries] = useState([]);
    const fleetIds = options.fleet.map((fleet) => fleet.ID).join(",");
    const vesselTypes = options.vesselTypes.join(",");
    useEffect(() => {
        if (!options.isReady)
            return;
        setSeries([]);
        setLoading(true);
        const params = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            vesselTypes,
            fleets: fleetIds,
            locationId: options.locationId == null ? "" : String(options.locationId),
        });
        fetch(`/api/benchmark/ncdayspermonthportvisit?${params}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data.length === 0) {
                return;
            }
            setSeries([
                {
                    type: "spline",
                    data: data.map((item) => [Date.parse(item.MonthAsDate), item.Fleet]),
                    name: "Your fleet",
                    yAxis: 0,
                    color: "#5e90c3",
                },
                {
                    type: "spline",
                    data: data.map((item) => {
                        const parsedValue = item.Industry == null ? null : Number(item.Industry);
                        return [Date.parse(item.MonthAsDate), Number.isNaN(parsedValue) ? null : parsedValue];
                    }),
                    name: "Industry data",
                    yAxis: 0,
                    color: "#6c757d",
                },
            ]);
        })
            .catch(() => {
            notifyError("An error has occurred when loading NC per vessel data. Please try again.");
        })
            .finally(() => setLoading(false));
    }, [options.isReady, options.startDate, options.endDate, vesselTypes, fleetIds, options.locationId]);
    const chartOptions = useMemo(() => ({
        title: { text: undefined },
        chart: { styledMode: false },
        exporting: { enabled: false },
        legend: {
            symbolHeight: 20,
            symbolRadius: 0,
            symbolWidth: 20,
        },
        plotOptions: {
            series: {
                dataLabels: { enabled: false },
                marker: { enabled: false },
                tooltip: { dateTimeLabelFormats: { month: "%b-%y" } },
            },
        },
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: { month: "%b-%y" },
        },
        yAxis: {
            title: { text: "Average per vessel" },
        },
        tooltip: {
            xDateFormat: "%b-%y",
            shared: true,
            valueDecimals: 3,
        },
        series,
    }), [series]);
    if (loading) {
        return (_jsx(BenchmarkCard, { title: title, children: _jsx(WkoLoadingSpinner, {}) }));
    }
    if (series.length === 0) {
        return (_jsx(BenchmarkCard, { title: title, children: _jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) }) }));
    }
    return (_jsx(BenchmarkCard, { title: title, children: _jsx(WkoHighchart, { options: chartOptions }) }));
};
